import React from "react";
import { useAccess } from "../hooks/useAccess";

/**
 * Renders children only when the permission is granted.
 * Nothing is rendered until access is resolved, so protected UI never flashes.
 *
 *   <AccessGuard permission="campaign.request.create" resource={{ restaurantId }}>
 *     <ActivateCampaignButton />
 *   </AccessGuard>
 *
 * `any` / `all` accept a list of permissions instead (an empty list denies).
 */
export function AccessGuard({
  permission,
  any,
  all,
  resource,
  fallback = null,
  children,
}) {
  const { can, canAny, canAll, isAccessReady } = useAccess();
  if (!isAccessReady) return null;

  let allowed = false;
  if (permission !== undefined) allowed = can(permission, resource);
  else if (any !== undefined) allowed = canAny(any, resource);
  else if (all !== undefined) allowed = canAll(all, resource);

  return allowed ? <>{children}</> : <>{fallback}</>;
}

export default AccessGuard;
